import { render, staticRenderFns } from "./more-show.vue?vue&type=template&id=2ea1db52&scoped=true"
import script from "./more-show.vue?vue&type=script&lang=js"
export * from "./more-show.vue?vue&type=script&lang=js"
import style0 from "./more-show.vue?vue&type=style&index=0&id=2ea1db52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea1db52",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonCarouselItemStatic: require('/builds/wj/fe/wenjuan-homesite/components/common/carousel-item-static.vue').default,CommonGridRow: require('/builds/wj/fe/wenjuan-homesite/components/common/grid-row.vue').default,CommonWrap: require('/builds/wj/fe/wenjuan-homesite/components/common/wrap.vue').default})
